function detailMessage(value: unknown): string {
  if (typeof value === "string") return value.trim();
  if (Array.isArray(value)) {
    return value.map(detailMessage).filter(Boolean).join("；");
  }
  if (value && typeof value === "object") {
    const item = value as Record<string, unknown>;
    // Only display message fields, never validation input or context (may contain passwords).
    return detailMessage(item.msg) || detailMessage(item.message) || detailMessage(item.detail);
  }
  return "";
}

export function apiErrorMessage(text: string, status: number): string {
  const fallback = `HTTP ${status}`;
  try {
    const body: unknown = JSON.parse(text);
    return detailMessage(body) || fallback;
  } catch {
    return text.trim() || fallback;
  }
}
